import { Box } from "@chakra-ui/react"
import type { ReactNode } from "react"

interface CheckboxProps {
  checked?: boolean
  onCheckedChange?: (details: { checked: boolean }) => void
  children?: ReactNode
  disabled?: boolean
}

export const Checkbox = ({
  checked = false,
  onCheckedChange,
  children,
  disabled = false,
}: CheckboxProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newChecked = e.target.checked
    onCheckedChange?.({ checked: newChecked })
  }

  return (
    <Box
      as="label"
      display="flex"
      alignItems="center"
      gap={3}
      cursor={disabled ? "not-allowed" : "pointer"}
      opacity={disabled ? 0.6 : 1}
      userSelect="none"
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        style={{
          width: "18px",
          height: "18px",
          cursor: disabled ? "not-allowed" : "pointer",
          accentColor: "var(--chakra-colors-teal-500)",
        }}
      />
      {children && (
        <Box as="span" fontSize="md">
          {children}
        </Box>
      )}
    </Box>
  )
}

export default Checkbox
